import React, { useMemo, useState } from 'react';
import PortfolioSimulator from '../../components/PortfolioSimulator';
import PageHeading from '../../components/PageHeading';
import usePersonalSimData from './usePersonalSimData';
import MyStrategiesManager from './MyStrategiesManager';
import { ProUpsell, EmptySources } from './PersonalCommon';
import './personal.css';

/*
 * Portfolio Simulator for a self user: the same simulator company members
 * get, with tabs for their accounts ("My portfolio") and their own strategies
 * ("My strategies") instead of a brand's strategies.
 */
export default function MySimulatorPage({ user, isPro, onNavigate, onUpgrade }) {
  const { data, requiresPro, myStrategies, reload } = usePersonalSimData();
  const [managing, setManaging] = useState(false);

  const personal = useMemo(() => ({
    ...data,
    only: true,
    headerAction: (
      <button type="button" className="mys-btn" onClick={() => setManaging(true)}>
        My strategies{myStrategies.length ? ` (${myStrategies.length})` : ''}
      </button>
    ),
  }), [data, myStrategies.length]);

  let body;
  if (!isPro || requiresPro) body = <div className="myr-page"><ProUpsell what="The Portfolio Simulator" onUpgrade={onUpgrade} /></div>;
  else if (!data.loading && !data.error && !data.strategies.length) body = <div className="myr-page"><EmptySources onNavigate={onNavigate} onStrategies={() => setManaging(true)} /></div>;
  else body = <PortfolioSimulator user={user} onUpgrade={onUpgrade} personal={personal} />;

  return (
    <>
      <PageHeading title="Portfolio Simulator" description="Model your accounts and your own strategies, alone or together." />
      {body}
      {managing ? <MyStrategiesManager strategies={myStrategies} onClose={() => setManaging(false)} onChanged={reload} /> : null}
    </>
  );
}
